import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan } from '../../misc';
import { trackEvent } from '../../../utils/ga-tracking';
import SubsectionInFrame from '../../misc/SubsectionInFrame';

const HowToFindMorePhotosInformation = ({
  participantMediaCount,
  onScrollToExtendedSearch,
}) => {
  return (
    <div className="row mb-20 mt-20">
      <div className="col-xs-16 col-sm-12 col-sm-offset-2">
        <SubsectionInFrame
          title={
            <FormattedMessageWrappedInSpan
              id="howToFindMorePhotosInformation.heading"
              defaultMessage="Are you happy with the results?"
              className="typography uppercase typography-title_small"
              topPadding
            />
          }
        >
          <FormattedMessageWrappedInSpan
            id="howToFindMorePhotosInformation.description"
            defaultMessage="We found {count} personal photos, but you can search for more."
            values={{ count: participantMediaCount }}
            className="mt-20 mb-20"
          />
          <button
            onClick={() => {
              onScrollToExtendedSearch();
              trackEvent('Event', 'Search', 'Are there more photos of me box');
            }}
            className="full-width secondary-new subsection-action-button btn-in-media-list"
          >
            <FormattedMessageWrappedInSpan
              id="howToFindMorePhotosInformation.button"
              defaultMessage="+ Are there more photos of me?"
            />
          </button>
        </SubsectionInFrame>
      </div>
    </div>
  );
};

HowToFindMorePhotosInformation.propTypes = {
  participantMediaCount: PropTypes.number,
  onScrollToExtendedSearch: PropTypes.func,
};

export default HowToFindMorePhotosInformation;
